var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-file mb-min"},[_c('input',{staticClass:"custom-file-input",attrs:{"accept":_vm.accept,"name":_vm.name,"type":"file","id":_vm.id},on:{"change":_vm.fileLoaded}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"data-browse":"Browse","for":"pdf"}},[_c('span',[_vm._v(_vm._s(_vm.labelText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15ef0634","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/FileInput.vue
// module id = giek
// module chunks = 0 1